import axios from '../../../commons/gdprcontrol-axios'

const userSkeleton = {
  id: null,
  email: '',
  name: '',
  phone_number: '',
  tax_id: '',
  external_id: '',
  employment_start_date: null,
  employment_end_date: null
}

const state = {
  userProfile: null,
  user: Object.assign({}, userSkeleton)
}

const getters = {
  getUserProfile: state => state.userProfile,
  getUser: state => state.user
}

const actions = {
  fetchUserProfile: async ({ commit, state }) => {
    return axios.get('/api/rest-auth/user/', state.user)
      .then(response => {
        commit('storeUserProfile', response.data)
      })
  },

  fetchUser: async ({ commit }, userId) => {
    return axios.get(`/api/users/${userId}/`)
      .then(response => {
        commit('storeUser', response.data)
      })
  },

  saveNewUser: async ({ commit, state }) => {
    return axios.post('/api/users/', state.user)
      .then(response => {
        commit('storeUser', response.data)
      })
  },

  updateUser: async ({ commit, state }) => {
    return axios.put(`/api/users/${state.user.id}/`, state.user)
      .then(response => {
        commit('storeUser', response.data)
      })
  }
}

const mutations = {
  storeUserProfile: (state, user) => {
    state.userProfile = user
  },

  storeUser: (state, user) => {
    state.user = user
  },

  setAttribute (state, { name, value }) {
    state.user[name] = value
  },

  resetUser (state) {
    state.user = Object.assign({}, userSkeleton)
  }
}

export default { state, getters, actions, mutations, namespaced: true }



// WEBPACK FOOTER //
// ./src/store/modules/users/details.js